import { FORM_UPDATE, FORM_UNSET } from '@/store/actions/form/action-typs';

const initialState = Object.assign({}, {
  name: '',
  values: {}
});

const reducer = (state = initialState, { type, payload = null }) => {
  switch (type) {
    case FORM_UPDATE:
      return updateForm(state, payload);
    case FORM_UNSET:
      return unsetForm(state);
    default:
      return state;
  }
};

const updateForm = (state, payload) => {
  return {
    ...state,
    ...payload
  };
};

const unsetForm = (state) => {
  return initialState;
};

export default reducer;
